import React from "react";

/**
 * @param {Object} props
 * @param {string} [props.title]
 * Title for the tab section.
 * * @param {React.ReactNode} props.children
 * The tab content elements to be rendered inside the wrapper.
 */

const TabsWeapperSection = ({ title, children }) => {
  return <>{children}</>;
};

export default TabsWeapperSection;
